import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

/**
 * React hook which picks out event.target.value from received events, and
 * stores the value in its state.
 */
var useEventTargetValue = function useEventTargetValue(initialState) {
  var _React$useState = React.useState(initialState),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var handleEvent = function handleEvent(event) {
    setValue(event.target.value);
  };
  return [value, handleEvent];
};

export { useEventTargetValue };
